import { Button, Header, Segment } from "semantic-ui-react";

import React from "react";

import Flex from "../../../../../components/Flex/Flex";

export default function CreateProductionPublisherListItem({ publisher, onClick }) {
	return (
		<Segment style={{ width: 500, margin: "auto", height: 75 }}>
			<Flex alignItems="center" justifyContent="flex-start" style={{ height: "100%" }}>
				<Header as="h5" style={{ margin: 0 }}>
					{publisher.name}
				</Header>
			</Flex>

			<div>
				<Button
					basic
					circular
					icon="minus"
					style={{
						height: 28,
						width: 28,
						padding: 0,
						position: "absolute",
						right: 15,
						top: 22,
					}}
					onClick={onClick}
				/>
			</div>
		</Segment>
	);
}
